<nz-row>
  <nz-col [nzSpan]="24">
    <ul [nzMode]="'horizontal'" [nzTheme]="'light'" nz-menu>
      <li [nzTitle]="toolsForViewingTitle" nz-submenu>
        <ul>
          <li [nzMatchRouterExact]="true" [nzMatchRouter]="true" nz-menu-item>
            <a
              [rel]="'follow'"
              [routerLink]="'/'"
              i18n="@@menu-viewing-tools-group-profile-viewer-item-title"
              >Profile viewer</a
            >
          </li>
          <li [nzMatchRouterExact]="true" [nzMatchRouter]="true" nz-menu-item>
            <a
              [rel]="'follow'"
              [routerLink]="'/story-viewer'"
              i18n="@@menu-viewing-tools-group-story-viewer-item-title"
              >Story viewer</a
            >
          </li>
        </ul>
        <ng-template #toolsForViewingTitle>
          <nz-icon [nzTheme]="'outline'" [nzType]="'instagram'" />
          <span class="hide-on-mobile" i18n="@@menu-viewing-tools-group-title"
            >Tools for viewing</span
          >
        </ng-template>
      </li>
      <li [nzTitle]="toolsForDownloadingTitle" nz-submenu>
        <ul>
          <li [nzMatchRouterExact]="true" [nzMatchRouter]="true" nz-menu-item>
            <a
              [rel]="'follow'"
              [routerLink]="'/video-downloader'"
              i18n="@@menu-downloading-tools-group-video-downloader-item-title"
              >Video downloader</a
            >
          </li>
          <li [nzMatchRouterExact]="true" [nzMatchRouter]="true" nz-menu-item>
            <a
              [rel]="'follow'"
              [routerLink]="'/reel-downloader'"
              i18n="@@menu-downloading-tools-group-reel-downloader-item-title"
              >Reels downloader</a
            >
          </li>
          <li [nzMatchRouterExact]="true" [nzMatchRouter]="true" nz-menu-item>
            <a
              [rel]="'follow'"
              [routerLink]="'/photo-downloader'"
              i18n="@@menu-downloading-tools-group-photo-downloader-item-title"
              >Photo downloader</a
            >
          </li>
          <li [nzMatchRouterExact]="true" [nzMatchRouter]="true" nz-menu-item>
            <a
              [rel]="'follow'"
              [routerLink]="'/avatar-downloader'"
              i18n="@@menu-downloading-tools-group-avatar-downloader-item-title"
              >Avatar downloader</a
            >
          </li>
        </ul>
        <ng-template #toolsForDownloadingTitle>
          <nz-icon [nzTheme]="'outline'" [nzType]="'download'" />
          <span
            class="hide-on-mobile"
            i18n="@@menu-downloading-tools-group-title"
            >Tools for downloading</span
          >
        </ng-template>
      </li>
    </ul>
  </nz-col>
</nz-row>
